import Table, { ColumnsType } from 'antd/lib/table';
import { Invoice, invoiceStatusKorean } from '../../modules/invoices';
import { priceToString } from '../../util/utils';
import moment from 'moment';
import { Button, Col, Popconfirm, Row, Space } from 'antd';
import Title from 'antd/lib/typography/Title';
import styled from 'styled-components';
import { styledTable } from '../styled/mixin';
import { useEffect, useState } from 'react';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface SubInvoiceListComponentProps {
  data: Invoice[];
  openSubInvoiceDetailDrawer: (invoiceId: string) => void;
  openSubInvoiceCreateModal: () => void;
  excludeSubInvoice: (invoiceId: string) => void;
}

function SubInvoiceListComponent({
  data,
  openSubInvoiceDetailDrawer,
  openSubInvoiceCreateModal,
  excludeSubInvoice,
}: SubInvoiceListComponentProps) {
  const [tableTotal, setTableTotal] = useState<number>();

  useEffect(() => {
    setTableTotal(
      data.reduce(function (pre: any, next: any) {
        return pre + next.price;
      }, 0),
    );
  }, [data]);

  const columns: ColumnsType<Invoice> = [
    {
      title: '회사명',
      dataIndex: ['vendor', 'application', 'general', 'name'],
      defaultSortOrder: 'ascend',
      sorter: (a: Invoice, b: Invoice) =>
        a.vendor.application.general.name.localeCompare(
          b.vendor.application.general.name,
        ),
      width: '10%',
      render: (text: any, record: any) => (
        <>
          {/* <span
            className="clickable-table-item"
            onClick={() => openSubInvoiceDetailDrawer('' + record.id)}
          >
            {text}
          </span> */}
          {text}
        </>
      ),
    },
    {
      title: '카테고리',
      dataIndex: 'category',
      width: '10%',
    },
    {
      title: '청구일',
      dataIndex: 'billingDate',
      width: '10%',
      render: (text: any, record: any, index: any) =>
        record.usedDate === null
          ? ''
          : moment(record.billingDate).format('YYYY-MM-DD'),
    },
    {
      title: '제출자',
      dataIndex: ['submittedBy', 'name'],
      width: '7%',
      render: (text: any, record: any) => <>{text === null ? '' : text}</>,
    },
    {
      title: '상태',
      dataIndex: 'status',
      width: '7%',
      render: (text: any, record: Invoice) =>
        invoiceStatusKorean[record.status],
    },
    // {
    //   title: '설명',
    //   dataIndex: 'description',
    //   width: '10%',
    //   render: (text: any, record: any) => (
    //     <>
    //       {text === null ? (
    //         ''
    //       ) : (
    //         <Text ellipsis={true} style={{ width: '200px' }}>
    //           {text}
    //         </Text>
    //       )}
    //     </>
    //   ),
    // },
    {
      title: '금액(원)',
      dataIndex: 'price',
      sorter: (a: Invoice, b: Invoice) => a.price - b.price,
      width: '10%',
      align: 'right',
      render: (value: any, record: any, index: any) => priceToString(value),
    },
    {
      title: '',
      key: 'action',
      dataIndex: '',
      align: 'center',
      width: '3%',
      render: (text, record, index) => (
        <Space size="small">
          <div onClick={(e) => e.stopPropagation()}>
            <Popconfirm
              title="정말 제외하시겠습니까?"
              onConfirm={() => excludeSubInvoice('' + record.id)}
            >
              <Button size="small">제외</Button>
            </Popconfirm>
          </div>
        </Space>
      ),
    },
  ];

  console.log(data);

  return (
    <StyledDiv>
      <Row justify="space-between" style={{ marginTop: '50px' }}>
        <Col>
          <Title level={5}>하위 청구서</Title>
        </Col>
        <Col>
          <Space>
            <Button size="small" onClick={() => openSubInvoiceCreateModal()}>
              추가
            </Button>
          </Space>
        </Col>
      </Row>

      {data && (
        <Table<Invoice>
          rowKey="id"
          columns={columns}
          dataSource={data}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
            position: ['bottomCenter'],
          }}
          locale={{
            triggerDesc: '내림차순으로 정렬하려면 클릭하세요.',
            triggerAsc: '오름차순으로 정렬하려면 클릭하세요.',
            cancelSort: '정렬을 취소하려면 클릭하세요.',
          }}
          footer={() => (
            <Row justify="end" style={{ marginRight: '90px' }}>
              {'Total: ' +
                (tableTotal === undefined ? 0 : priceToString(tableTotal!))}
            </Row>
          )}
        />
      )}
    </StyledDiv>
  );
}
export default SubInvoiceListComponent;
